import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { RideGrid } from "@rimac-seguros/ride-system-components";

import { FormContainer } from "../FormContainer";
import { CardConditions } from "../CardConditions/index";
import { CardDetailPlan } from "../../../shared/components/CardDetailPlan/index";

import "./styles.scss";
import { usePlansContext } from "../../../step-plans/context/PlansContext";
import helpers from "@/utils/helpers";
import { getProductOptions } from "@/utils/product";

export const SectionPayment = ({ title, ...props }) => {
  const { planSelected, maxAmountQuote } = useSelector(
      (state) => state.plans
    );
    const { sumAssured } = planSelected || {};
  const { digitalDataProductName } = getProductOptions();
  const isCreditMaxAmount = Number(sumAssured?.value) > maxAmountQuote;
  const { isLoadingData } = usePlansContext();

  const callAnalyticsAction = () => {
    helpers.setActionTag({
      group: digitalDataProductName,
      category: "Resumen y pago",
      action: "click",
      label: "Ver detalle",
    });
  };

  return (
    <RideGrid className="section-payment">
      <div className="section-payment_title">
        <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>
      </div>
      <div className="order-3 col-span-full lg:col-span-7 lg:order-2 xl:col-span-6">
        <FormContainer {...props} />
        <CardConditions />
      </div>
      <div className="hidden lg:block order-2 col-span-full lg:col-span-5 lg:order-3 lg:col-start-8">
        {!isCreditMaxAmount &&
          <CardDetailPlan
            shouldDisplayBeneficiaries
            isLoadingData={isLoadingData}
            callAnalyticsAction={callAnalyticsAction}
          />
        }
      </div>
    </RideGrid>
  );
};